import { axios, getResponse, isUndNullEmp, settings } from '../../helpers/main';
import { userAuthContextType } from '../../auth/AuthProvider';

const authServices = { user: userAuthContextType }; //eslint-disable-line
const objectService = getResponse({ type: 0 }); //eslint-disable-line

export class PaymentInformationService {
    /**
     * @param {object} params
     * @param {string} params.token
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @param {authServices} params.auth
     * @returns {Promise<objectService>}
     * @description 
     */
    static getAllWithDetailsAsync = async ({
        token = '',
        languageId = 'en',
        subMethod = '',
        auth = authServices,
    } = {}) => {
        const currentMethod = 'getAllWithDetailsAsync';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.paymentInformations}/`,
                headers: {
                    authorization: `bearer ${token}`,
                },
                data: {
                    method: settings?.backend?.methods?.paymentInformations?.getAllWithDetails,
                    languageId: languageId,
                },
                subMethod: subMethod || currentMethod,
            };
            response = await axios.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {object} params
     * @param {string} params.token
     * @param {string} params.id
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @param {authServices} params.auth
     * @returns {Promise<objectService>}
     * @description 
     */
    static getById = async ({
        token = '',
        id = '',
        languageId = 'en',
        subMethod = '',
        auth = authServices,
    } = {}) => {
        const currentMethod = 'getById';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.paymentInformations}/`,
                headers: {
                    authorization: `bearer ${token}`,
                },
                data: {
                    id: id,
                    method: settings?.backend?.methods?.paymentInformations?.getById,
                    languageId: languageId,
                },
                subMethod: subMethod || currentMethod,
            };
            response = await axios.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {object} params
     * @param {string} params.token
     * @param {object} params.data
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @param {authServices} params.auth
     * @returns {Promise<objectService>}
     * @description 
     */
    static create = async ({
        token = '',
        data = {},
        languageId = 'en',
        subMethod = '',
        auth = authServices,
    } = {}) => {
        const currentMethod = 'create';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.paymentInformations}/`,
                headers: {
                    authorization: `bearer ${token}`,
                },
                data: {
                    data: data,
                    languageId: languageId,
                },
                subMethod: subMethod || currentMethod,
            };
            response = await axios.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {object} params
     * @param {string} params.token
     * @param {object} params.data
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @param {authServices} params.auth
     * @returns {Promise<objectService>}
     * @description update the payment information
     */
    static update = async ({
        token = '',
        data = {},
        languageId = 'en',
        subMethod = '',
        auth = authServices,
    } = {}) => {
        const currentMethod = 'update';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.paymentInformations}/${data?.id}`,
                headers: {
                    authorization: `bearer ${token}`,
                },
                data: {
                    data: data,
                    languageId: languageId,
                },
                subMethod: subMethod || currentMethod,
            };
            response = await axios.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {object} params
     * @param {string} params.token
     * @param {string} params.id
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @param {authServices} params.auth
     * @returns {Promise<objectService>}
     * @description delete the payment information
     */
    static deleteAsync = async ({
        token = '',
        id = '',
        languageId = 'en',
        subMethod = '',
        auth = authServices,
    } = {}) => {
        const currentMethod = 'deleteAsync';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.paymentInformations}/${id}`,
                headers: {
                    authorization: `bearer ${token}`,
                },
                data: {
                    languageId: languageId,
                },
                subMethod: subMethod || currentMethod,
            };
            response = await axios.delete(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
}
